/*
 * menu-trigger btn
 * ----------------------------------------------- */
jQuery(function ($) {
  var $menuTrigger = $(".menu-trigger");

  const movefun = function (event) {
    event.preventDefault();
  };

  $menuTrigger.on("click", function (e) {
    e.preventDefault();

    $(this).toggleClass("active");
    $(".header-inner .nav").slideToggle();

    if ($("body").hasClass("no-scroll")) {
      $("body").removeClass("no-scroll");
      $(window).off(".noScroll");

      // スクロール停止することを停止する処理
      window.removeEventListener("touchmove", movefun, { passive: false });
    } else {
      $("body").addClass("no-scroll");
      $(window).on("touchmove.noScroll", function (e) {
        e.preventDefault();
      });

      // スクロール停止の処理
      window.addEventListener("touchmove", movefun, { passive: false });
    }
  });
});
